import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { StoreState } from '../../store'
import { Back, Container, Content, Form, Title } from './styles'
import { useForm, SubmitHandler } from 'react-hook-form'
import { BsArrowLeftShort } from 'react-icons/bs'
import key from '../../assets/key-64.svg'
import { FiKey } from 'react-icons/fi'
import { toast } from 'react-hot-toast'
import * as yup from 'yup'
import api from '../../services/axios'
import { get } from 'lodash'
interface Inputs {
    email: string
}

const schema = yup.string().email().required()

const RecuperarSenha: React.FC = () => {
    const navigate = useNavigate()
    const { isLoggedIn } = useSelector((state: StoreState) => state.auth)
    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm<Inputs>()
    useEffect(() => {
        if (isLoggedIn) navigate('/dashboard')
    }, [navigate, isLoggedIn])

    const submit: SubmitHandler<Inputs> = async (inputs) => {
        try {
            const isEmailValid = await schema.isValid(inputs.email)

            if (!isEmailValid) {
                return toast.error('Email inválido')
            }

            await api.post('/reset-password', {
                email: inputs.email,
            })

            return toast.success('Enviamos um email para você :)')
        } catch (error) {
            const messageError = get(error, 'response.data.error', '')

            return toast.error(messageError)
        }
    }

    const baseStyleInputs =
        'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
    return (
        <Container>
            <Content>
                <Title>
                    <div className="key">
                        <span className="background">
                            <span>
                                <FiKey size={28} color="#3BAE5B" />
                            </span>
                        </span>
                    </div>
                    <h1 className="text-3xl text-gray-900 mb-2">
                        Esqueceu sua senha?
                    </h1>
                    <h3 className="text-base text-gray-500">
                        Não se preocupe, vamos enviar link para seu email para
                        resetar sua senha.
                    </h3>
                </Title>
                <Form onSubmit={handleSubmit(submit)}>
                    <div className="field">
                        <div className="relative">
                            <label
                                htmlFor="email"
                                className="text-gray-700 text-sm label"
                            >
                                Insira o endereço de e-mail associado à sua
                                conta Tree
                                <span className="text-red-500 required-dot">
                                    *
                                </span>
                            </label>
                            <input
                                type="text"
                                id="email"
                                {...register('email', {
                                    required: 'O campo email é obrigatório',
                                    minLength: 3,
                                    maxLength: 255,
                                })}
                                className={
                                    errors.email &&
                                    (errors.email.type === 'required' ||
                                        errors.email.type === 'minLength' ||
                                        errors.email.type === 'maxLength')
                                        ? `${baseStyleInputs} ring-red-500 ring-2`
                                        : baseStyleInputs
                                }
                                placeholder="Seu e-mail"
                            />
                            {errors.email &&
                                (errors.email.type === 'required' ||
                                    errors.email.type === 'minLength' ||
                                    errors.email.type === 'maxLength') && (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="15"
                                        height="15"
                                        fill="currentColor"
                                        className="absolute text-red-500 right-2 bottom-3"
                                        viewBox="0 0 1792 1792"
                                    >
                                        <path d="M1024 1375v-190q0-14-9.5-23.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 23.5v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zm-2-374l18-459q0-12-10-19-13-11-24-11h-220q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zm-14-934l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17h-1536q-34 0-63.5-17t-46.5-46q-37-63-2-126l768-1408q17-31 47-49t65-18 65 18 47 49z"></path>
                                    </svg>
                                )}
                        </div>
                    </div>
                    <div className="actions">
                        <button
                            type="submit"
                            className="py-2 px-4  bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 focus:ring-offset-blue-200 text-white w-full transition ease-in duration-200 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg "
                        >
                            Continuar
                        </button>
                    </div>
                </Form>
                <Back>
                    <Link to="/login" className="text-base text-gray-700">
                        <BsArrowLeftShort size={22} />
                        Voltar para login
                    </Link>
                </Back>
            </Content>
        </Container>
    )
}

export default RecuperarSenha
